import React, { useState } from "react";
import "./Contact.css";
import { Footer } from "../footer/Footer";
import { Header } from "../../header/Header";
import emailjs from "@emailjs/browser";

export const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    message: ""
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
  const phoneRegex = /^\d{10}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const templateParams = {
    name: formData.name,
    email: formData.email,
    contact: formData.contact,
    message: formData.message,
  };

  if (!phoneRegex.test(formData.contact)) {
    alert("Please enter a valid 10-digit contact number.");
    return;
  }

  if (!emailRegex.test(formData.email)) {
    alert("Please enter a valid email address.");
    return;
  }

  emailjs.send(
    'service_kttrjzk',
    'template_203txal',
    {
      name: formData.name,
      email: formData.email,
      contact: formData.contact,
      message: formData.message,
    },
    'ZEdPUF87tkzN3rxzl'
  ).then(
    (result) => {
      console.log('Email sent successfully:', result.text);
    },
    (error) => {
      console.error('Email sending failed:', error.text);
    }
  );
    alert("Thank you for contacting us!");
    setFormData({ name: "", email: "", contact: "", message: "" });
  };

  return (
    <>
    <Header />
    <div className="contact-container">
      <h2>Contact Us</h2>
      <form onSubmit={handleSubmit} className="contact-form">
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <input
          type="tel"
          name="contact"
          placeholder="Contact No"
          value={formData.contact}
          onChange={handleChange}
          pattern="^\d{10}$"
          title="Please enter a 10-digit phone number"
          required
        />
          
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        
        <textarea
          name="message"
          placeholder="Your Message"
          rows={5}
          value={formData.message}
          onChange={handleChange}
          required
        />
        
        <button type="submit">Send Message</button>
      </form>
    </div>
    <Footer />
    </>
  );
};
